module.exports = __webpack_public_path__ + "img/Checked.eee1cc92.svg";